const PASSWORD_MIN_LENGTH = 8;

/** Unicode decimal digits, as Python's `str.isdigit()` reads them. */
const ALL_DIGITS = /^\p{Nd}+$/u;

/**
 * The server's codes for every rule above that *password* breaks, for a checklist that
 * shows them all at once (`validatePassword` stops at the first).
 */
export function passwordRuleCodes(password: string): string[] {
  return [
    ...(password.length < PASSWORD_MIN_LENGTH ? ["password_too_short"] : []),
    ...(ALL_DIGITS.test(password) ? ["password_entirely_numeric"] : []),
  ];
}

/**
 * Validates a password and optional confirmation.
 * Returns an i18n key for the error, or null if valid.
 *
 * Only the server's rules a browser can check exactly live here (Django's
 * MinimumLengthValidator and NumericPasswordValidator). Common, breached and
 * too-similar passwords need the server, so this passing never means the server
 * will accept the password: it stays the authority.
 */
export function validatePassword(password: string, confirmPassword?: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return "auth.password_min_length";
  }
  if (ALL_DIGITS.test(password)) {
    return "auth.password_entirely_numeric";
  }
  if (confirmPassword !== undefined && password !== confirmPassword) {
    return "auth.passwords_mismatch";
  }
  return null;
}
